import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function MostUsedCard({ name, numberOfUses, cover }) {
  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: "#F5F5F5",
        borderRadius: "30px",
        boxShadow: "0px 0px 10px 0px rgb(88 88 88 / 10%) inset",
        display: "flex",
        flexDirection: "column",
        height: "130px",
        overflow: "hidden",
        textAlign: "center",
        width: "130px",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          backgroundImage: `url(${cover})`,
          backgroundClip: "border-box",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          borderRadius: "30px 30px 0 0",
          boxShadow: "0px 0px 10px 0px rgb(88 88 88 / 20%) inset",
          height: "80px",
          width: "130px",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          justifyContent: "center",
        }}
      >
        <Typography
          fontWeight={600}
          sx={{ userSelect: "none" }}
          title={name}
          variant="caption"
        >
          {name.length > 10
            ? `${name.slice(0, 10).toUpperCase()}...`
            : name.toUpperCase()}
        </Typography>
        {/* <Typography
          sx={{ userSelect: "none" }}
          title={ `${numberOfUses} vezes` }
          variant="caption"
        >
          { `${numberOfUses} vezes` }
        </Typography> */}
      </Box>
    </Box>
  );
}
